/**
 * i.e. HTTP 401
 */
export class UnauthorizedError extends Error {}
